// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__3-mhT","notes":"Notes_notes__hSZjD"};